module.exports = __webpack_public_path__ + "img/withdraw.69e4fe30.svg";